// extracted by mini-css-extract-plugin
export default {"NewUser":"NewUser_NewUser__sX7gv","actions":"NewUser_actions__AtE0l"};